import { Chip, MenuItem, InputLabel, Select } from "@mui/material";
import clsx from "clsx";
import { Fragment } from "react";
import { createUseStyles } from "react-jss";
import { theme } from "$utils/theme/bataillog";
import { toTime } from "$utils/utils";

const horraireFill = (option: "matin" | "midi"): any[] => {
  const depart = option === "matin" ? 5 : 12.5;
  const end = option === "matin" ? 12.5 : 24;
  const times = [];
  for (let i = depart; i < end; i += 0.5) {
    times.push({
      value: i,
      label: `${toTime(i)} - ${toTime(i + 0.5)}`,
    });
  }
  return times;
};

type Props = {
  label: string;
  isMorning: boolean;
  value?: any;
  onChange?: (value: any) => void;
  error?: boolean;
  isRequired?: boolean;
};

function ScheduleSelect({
  label,
  isMorning = true,
  error = false,
  isRequired = false,
  ...props
}: Props) {
  const classes = useStyles();

  const handleDeleteValue = (i: number) => {
    props.onChange(props.value.filter((h: number) => h !== i));
  };

  return (
    <div style={{ width: "100%" }}>
      <InputLabel className={error ? classes.labelError : classes.label}>
        {label}
        {isRequired && " *"}
      </InputLabel>
      <Select
        {...props}
        MenuProps={{
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "left",
          },
          transformOrigin: {
            vertical: "top",
            horizontal: "left",
          },
          // getContentAnchorEl has been removed in MUI v5
          // Instead, anchorOrigin and transformOrigin are used to control positioning
        }}
        labelId={isMorning ? "matin-id" : "midi-id"}
        id={isMorning ? "matin" : "midi"}
        variant="outlined"
        multiple
        placeholder="Sélectionnez le(s) créneau(x)"
        renderValue={() => "Sélectionnez le(s) créneau(x)"}
        style={{ width: "100%" }}
        className={error ? classes.errorSelect : undefined}
      >
        {horraireFill(isMorning ? "matin" : "midi").map(({ value, label }) => (
          <MenuItem
            value={value}
            key={`${isMorning ? "matin" : "midi"}-${value}`}
            className={clsx("")}
          >
            {label}
          </MenuItem>
        ))}
      </Select>
      <div className={classes.chipContainer}>
        {horraireFill(isMorning ? "matin" : "midi")
          .filter(({ value }) => props?.value?.includes(value))
          .map(({ value, label }) => (
            <Fragment key={`${isMorning ? "matin2" : "midi2"}-${value}`}>
              <Chip
                className={classes.chip}
                label={label}
                onClick={props.onChange}
                onDelete={() => handleDeleteValue(value)}
              />
            </Fragment>
          ))}
      </div>
    </div>
  );
}

export default ScheduleSelect;

const useStyles = createUseStyles(() => ({
  chipContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    marginTop: 4,
  },
  chip: {
    "&.MuiChip-root": {
      margin: [4, 0],
      color: theme.color.blueLight,
      "& .MuiSvgIcon-root": {
        color: `${theme.color.blueLight} !important`,
      },
      background: "#DAE6F4",
    },
  },
  label: {
    position: "relative",
    fontSize: "14px !important",
    marginBottom: 8,
  },
  labelError: {
    position: "relative",
    fontSize: "14px !important",
    marginBottom: 8,
    color: `${theme.color.red} !important`,
  },
  errorSelect: {
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: `${theme.color.red} !important`,
    },
  },
}));
